<template>
  <div style="padding-bottom: 3rem">
    <div class="results-spinner" v-if="showSpinner">
      <load-spinner></load-spinner>
    </div>
    <div class="columns is-multiline video-results video-tiles-view">
      <div class="column is-4" v-for="video in resultsShowing" :key="video.id">
        <video-item :item="video"></video-item>
      </div>

      <no-results v-if="showNoResults"></no-results>
      <div class="column is-10 bottom-hr-row" v-if="results.length > 0"></div>
    </div>
    <div class="load-more" v-if="showAddMore">
      <a href="#" @click.prevent="loadMore">
        <svg
          width="20"
          height="20"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.58366 4.08366H6.41699V6.41699H4.08366V7.58366H6.41699V9.91699H7.58366V7.58366H9.91699V6.41699H7.58366V4.08366ZM7.00033 1.16699C3.78033 1.16699 1.16699 3.78033 1.16699 7.00033C1.16699 10.2203 3.78033 12.8337 7.00033 12.8337C10.2203 12.8337 12.8337 10.2203 12.8337 7.00033C12.8337 3.78033 10.2203 1.16699 7.00033 1.16699ZM7.00033 11.667C4.42783 11.667 2.33366 9.57283 2.33366 7.00033C2.33366 4.42783 4.42783 2.33366 7.00033 2.33366C9.57283 2.33366 11.667 4.42783 11.667 7.00033C11.667 9.57283 9.57283 11.667 7.00033 11.667Z"
            fill="currentColor"
          />
        </svg>

        הראה לי עוד
      </a>
    </div>
  </div>
</template>

<script>
import VideoItem from "@/components/VideoItem.vue";
import LoadSpinner from "@/components/LoadSpinner.vue";
import NoResults from "@/components/NoResults.vue";

export default {
  props: {
    showSpinner: Boolean,
    showNoResults: Boolean,
    results: Array,
  },
  components: {
    VideoItem,
    LoadSpinner,
    NoResults,
  },
  data() {
    return {
      resultsShowing: [],
      filtered: 0,
      page: 1,
    };
  },
  computed: {
    showAddMore() {
      if (this.filtered > this.resultsShowing.length) {
        return true;
      }
      return false;
    },
    sortBy() {
      return this.$store.state.sort.sortby;
    },
  },
  methods: {
    loadMore() {
      const vm = this;
      const page = document.getElementsByTagName("html")[0];
      const initial = page.scrollTop;
      this.page = this.page + 1;
      this.$store.dispatch("addPage");
      if (
        this.$store.state.sort.page > 1 &&
        this.results.length > this.resultsShowing.length
      ) {
        const remaining = this.results.length - this.resultsShowing.length;

        const start = (this.page - 1) * 9;
        if (remaining > 8) {
          const existing = this.resultsShowing;
          const toAdd = this.results.slice(start, start + 9);

          this.resultsShowing = [...existing, ...toAdd];
          vm.$nextTick(() => {
            page.scrollTop = page.scrollTop - (page.scrollTop - initial);
          });
        } else {
          this.resultsShowing = [
            ...this.resultsShowing,
            ...this.results.slice(start, this.results.length),
          ];
        }
      }
    },
  },
  watch: {
    results() {
      this.page = 1;
      if (this.results.length > 9) {
        this.resultsShowing = this.results.slice(0, 9);
      } else {
        this.resultsShowing = this.results;
      }
      this.filtered = this.results.length;
      this.$emit("filtered-results", { filtered: this.filtered });
    },
    sortBy() {
      this.page = 1;
      this.$store.dispatch("sortGetResults", this.results);
      this.$emit("filtered-results", { filtered: this.results.length });
      if (this.sortBy === 4) {
        this.resultsShowing = this.results.filter(
          item => item.type && item.type === "series"
        );
        this.filtered = this.resultsShowing.length;
        this.$emit("filtered-results", { filtered: this.filtered });
      }
      if (this.sortBy === 5) {
        this.resultsShowing = this.results.filter(item => !item.type);
        this.filtered = this.resultsShowing.length;
        this.$emit("filtered-results", { filtered: this.filtered });
      }
      if (this.sortBy === 6) {
        this.resultsShowing = this.results.filter(item => {
          return this.$store.state.user.history.indexOf(`${item.id}`) === -1;
        });
        this.filtered = this.resultsShowing.length;
        this.$emit("filtered-results", { filtered: this.filtered });
      }
      if (this.resultsShowing.length > this.page * 8) {
        this.resultsShowing = this.resultsShowing.slice(0, this.page * 9);
      }
    },
  },
  mounted() {
    this.page = this.$store.state.sort.page;
    if (this.results.length > this.page * 8) {
      this.resultsShowing = this.results.slice(0, this.page * 9);
    } else {
      this.resultsShowing = this.results;
    }
    this.filtered = this.results.length;
  },
};
</script>

<style lang="scss">
.video-results.columns:not(:last-child) {
  background-color: #eeeeee;
  margin-bottom: 0;

  .bottom-hr-row {
    margin-right: 8.33333%;
  }
}

.results-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
}

.load-more {
  padding-bottom: 3rem;
  text-align: center;
  a {
    color: #787878;
    font-size: 1.2rem;
    border: 0;
    padding-right: 1rem;
    border-radius: 20px;
    -webkit-box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25);
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25);
    padding: 0.5rem 1.2rem;
    background-color: #ffffff;
    svg {
      position: relative;
      top: 3px;
    }
  }
}

@media screen and (min-width: 1024px) {
  .video-results {
    padding: 30px 0 0;
  }
}
</style>
